import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../shared/components/AppButton";
import { AppCheckbox } from "../../../../../shared/components/AppCheckbox";
import styles from "./styles.module.css";

interface Props {
  isChecked: boolean;
  onAgreementChange: () => void;
  handleOpenAgreement: () => void;
}

export const UserAgreementCheckbox = (props: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        onClick={props.onAgreementChange}
        className={styles["agreement-container"]}
      >
        <AppCheckbox
          checked={props.isChecked}
          className={styles["agreement-checkbox"]}
        />
        <AppButton buttonType={"text"} onClick={props.handleOpenAgreement}>
          {t("login.user_agreement")}
        </AppButton>
      </div>
    </>
  );
};
